export default function SafetySection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-2/5">
            <span className="text-xs font-semibold tracking-[0.15em] text-foreground-500 font-label uppercase">How It Works</span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mt-3 mb-8">
              How Superbuy Spreadsheet Works
            </h2>
            <div className="space-y-6">
              {[
                { step: '01', title: 'Choose Category', desc: 'Browse through 14 organized product categories to find exactly what interests you.' },
                { step: '02', title: 'Browse Spreadsheet', desc: 'Access curated product lists with direct links, prices, and detailed information.' },
                { step: '03', title: 'Review Product Details', desc: 'Compare items, check photos and descriptions before making your decision.' },
                { step: '04', title: 'Continue Shopping', desc: 'Follow links to the main platform and complete your shopping journey.' },
              ].map((item, idx) => (
                <div key={item.step} className="flex gap-5 items-start">
                  <span className="text-3xl font-heading font-bold text-accent-400 flex-shrink-0 w-14">{item.step}</span>
                  <div>
                    <h4 className="text-lg font-heading font-semibold text-foreground-950 mb-1">{item.title}</h4>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-3/5">
            <span className="text-xs font-semibold tracking-[0.15em] text-foreground-500 font-label uppercase">Safety &amp; Transparency</span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mt-3 mb-8">
              Shopping With Confidence
            </h2>
            <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-foreground-100/60">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                {[
                  { icon: 'ri-shield-check-line', text: 'We do not sell products directly — we are an educational resource platform' },
                  { icon: 'ri-lock-line', text: 'We do not handle payments or store any financial information' },
                  { icon: 'ri-eye-off-line', text: 'We do not store personal information or browsing history' },
                  { icon: 'ri-user-search-line', text: 'Users should verify sellers independently before purchasing' },
                  { icon: 'ri-file-list-3-line', text: 'Always review product details and seller ratings before buying' },
                  { icon: 'ri-scales-line', text: 'Respect intellectual property policies and shop responsibly' },
                ].map((item) => (
                  <div key={item.text} className="flex gap-3 items-start">
                    <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className={`${item.icon} text-accent-700 text-sm w-5 h-5 flex items-center justify-center`}></i>
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}